import { useState } from "react";
import { faqItems } from "@/mocks/guatian";

export default function Faq() {
  const [openIdx, setOpenIdx] = useState<number>(0);

  return (
    <section id="guide" className="bg-background-50">
      <div className="mx-auto max-w-[1280px] px-4 py-12 md:px-6 md:py-16">
        <div className="grid gap-10 lg:grid-cols-[0.85fr_1.5fr] lg:gap-14">
          <div className="lg:sticky lg:top-24 lg:self-start">
            <div className="inline-flex items-center gap-2 rounded-full bg-primary-100 px-3 py-1.5 text-xs font-bold text-primary-700">
              <i className="ri-question-line" aria-hidden="true"></i>
              吃瓜指南 FAQ
            </div>
            <h2 className="mt-3 text-2xl font-bold leading-tight tracking-tight text-foreground-950 md:text-4xl">
              关于站内信息，<br />你想知道的<span className="text-primary-600">都在这</span>
            </h2>
            <p className="mt-4 text-sm leading-6 text-foreground-500">
              我们从高频提问中整理出最受关注的几条，覆盖内容口径、核实机制、投稿与订阅方式。
            </p>

            <div className="mt-6 rounded-lg border border-background-200 bg-background-100/70 p-5">
              <div className="flex items-center gap-3">
                <span className="flex h-10 w-10 items-center justify-center rounded-md bg-primary-600 text-background-50">
                  <i className="ri-user-star-line" aria-hidden="true"></i>
                </span>
                <div>
                  <p className="text-sm font-bold text-foreground-900">编辑团队的承诺</p>
                  <p className="text-xs text-foreground-500">每条时间线都经来源标注与交叉核对</p>
                </div>
              </div>
              <ul className="mt-4 space-y-2">
                {["对事实负责，不替读者下结论", "对当事人保留基本尊重", "有偏差必更正并更新标注"].map((t) => (
                  <li key={t} className="flex items-center gap-2 text-sm text-foreground-700">
                    <i className="ri-checkbox-circle-line text-primary-600" aria-hidden="true"></i>
                    {t}
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <div>
            <div className="divide-y divide-background-200 overflow-hidden rounded-lg border border-background-200">
              {faqItems.map((f, i) => {
                const open = openIdx === i;
                return (
                  <div key={f.q} className="bg-background-50">
                    <button
                      onClick={() => setOpenIdx(open ? -1 : i)}
                      className="flex w-full items-center gap-4 px-5 py-5 text-left transition hover:bg-background-100/50 md:px-6"
                      aria-expanded={open}
                    >
                      <span className={`text-sm font-black ${open ? "text-accent-600" : "text-background-400"}`} style={{ fontFamily: "var(--font-label)" }}>
                        Q{i + 1}
                      </span>
                      <h3 className="flex-1 text-base font-bold leading-snug text-foreground-950">{f.q}</h3>
                      <i className={`ri-add-line text-xl text-foreground-400 transition ${open ? "rotate-45 text-accent-600" : ""}`} aria-hidden="true"></i>
                    </button>
                    <div className={`grid transition-all duration-300 ${open ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"}`}>
                      <div className="overflow-hidden">
                        <p className="px-5 pb-6 pl-[70px] text-sm leading-7 text-foreground-600 md:px-6 md:pl-[74px]">
                          {f.a}
                        </p>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
            <p className="mt-4 text-center text-sm text-foreground-400">
              没找到答案？欢迎在下方留言，我们每条都会看。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}